import { motion } from "framer-motion";

export const Circle = ({ color = "#FFE600", size = 200, x = 0, y = 0, blend = true, className = "", style = {} }) => (
  <div
    aria-hidden="true"
    className={`absolute rounded-full pointer-events-none ${blend ? "mix-blend-multiply" : ""} ${className}`}
    style={{ width: size, height: size, left: x, top: y, background: color, ...style }}
  />
);

export const CircleCluster = ({ className = "", scale = 1, animate = true }) => (
  <motion.div
    aria-hidden="true"
    className={`relative pointer-events-none ${className}`}
    style={{ width: 320 * scale, height: 240 * scale }}
    initial={animate ? { opacity: 0, y: 40 } : false}
    whileInView={animate ? { opacity: 1, y: 0 } : undefined}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
  >
    <div className="ink-dot absolute bg-staxyellow floaty" style={{ width: 200 * scale, height: 200 * scale, left: 0, top: 20 * scale }} />
    <div className="ink-dot absolute bg-staxcyan floaty" style={{ width: 150 * scale, height: 150 * scale, left: 110 * scale, top: 0, animationDelay: "-2s" }} />
    <div className="ink-dot absolute bg-staxmagenta floaty" style={{ width: 120 * scale, height: 120 * scale, left: 170 * scale, top: 100 * scale, animationDelay: "-4s" }} />
  </motion.div>
);

export const RegMark = ({ className = "" }) => (
  <div aria-hidden="true" className={`pointer-events-none ${className}`}>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="20" cy="20" r="14" />
      <line x1="20" y1="0" x2="20" y2="40" />
      <line x1="0" y1="20" x2="40" y2="20" />
    </svg>
  </div>
);
